import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const Container = styled.div`
  position: ${({ device }) => (device === 'desktop' ? 'absolute' : 'unset')};
  right: -220px;
  top: -76px;
  width: ${({ device }) => (device === 'desktop' ? '180px' : 'auto')};
  padding: ${({ device }) => (device === 'desktop' ? '0' : '0 8px')};
  margin: ${({ device }) => {
    if (device === 'desktop') return '0';
    if (device === 'mobile') return '0 16px 16px';
    return '0 24px 24px';
  }};
  border: ${({ device }) => (device !== 'desktop' ? `1px ${select('neutralDarkGray')} solid` : 'none')};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TipCardDesktop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${select('white')};
  white-space: pre-wrap;
  padding: 16px;
  font-family: Hind;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  vertical-align: middle;
  border: 1px ${select('neutralDarkGray')} solid;
  > img {
    width: 16px;
    height: 16px;
  }
`;

const TipCardMobile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  .text {
    font-family: Hind;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    white-space: normal;
    margin-top: 8px;
  }
`;

export { Container, TipCardDesktop, TipCardMobile };
